import { formatTime, computeTimeRange, cmpTime } from "./utils";

/**
 *
 * @param {[number, number]} minTime
 * @param {[number, number]} maxTime
 * @param {number} timeStep
 * @param {Array<[number, number]>} allowedTimes
 */
export const computeTimeList = (minTime, maxTime, timeStep, allowedTimes) =>
  computeTimeRange(minTime, maxTime, timeStep).map(t => ({
    str: formatTime(t),
    enabled: allowedTimes.some(time => cmpTime(t, time) === 0)
  }));
